import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Col, Row, Spinner } from "react-bootstrap";
import PgCard from "src/components/Card/PgCard";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import { mapPromotion } from "src/utils/mapPromotion";
import { promotionsLivePreviewRequestHandler } from "src/utils/promotionsLivePreviewHandler";

const PromotionCardPreview = () => {
  const { t, i18n } = useTranslation();
  const { card, isLoading } = useHubCardLivePreview(
    "promotions",
    { depth: 0, mapDoc: mapPromotion, requestHandler: promotionsLivePreviewRequestHandler },
    i18n.language
  );

  const buttonSettings = card?.url
    ? {
        href: card.url,
        label: card.buttonLabel || t("button.read-more"),
      }
    : null;

  return (
    <PreviewPage>
      <container-wide>
        <Row className="g-4 justify-content-center" xs={1}>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center w-100 py-5">
              <Spinner animation="border" variant="light" role="status">
                <span className="visually-hidden">{t("loading")}</span>
              </Spinner>
            </div>
          ) : !card ? (
            <div className="preview-status py-5 w-100">
              <p>{t("promotions.preview.waitingForDocument")}</p>
            </div>
          ) : (
            <Col xs={12} md={10} lg={8} xl={6}>
              <PgCard
                id={card.key}
                image={card.image}
                imageAlt={card.imageAlt || card.title}
                title={card.title}
                subtitle={t(`promotions.categories.${card.category}`, {
                  defaultValue: card.category,
                })}
                text={card.content}
                buttonSettings={buttonSettings}
              />
            </Col>
          )}
        </Row>
      </container-wide>
    </PreviewPage>
  );
};

const PreviewPage = styled.div`
  padding: 1.5rem 0 2rem;
  min-height: 100vh;
  background: var(--black);
  color: var(--white);

  .preview-status {
    text-align: center;
    color: var(--mutedwhite);
  }

  .pg-card {
    .card-header {
      flex-grow: 0;
    }
    .card-body {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      .card-text {
        flex-grow: 1;
      }
    }
  }
`;

export default PromotionCardPreview;
